type Listed = { items?: unknown[] } | undefined;

/**
 * Refetch an answers list until it grows past `itemCountBefore`, or attempts run out.
 * Autosave of a text answer lands in the asset registry after `end_answer`, so the
 * first refetch after a new question often still comes back empty.
 */
export async function refetchUntilItemCountIncreases(options: {
	itemCountBefore: number;
	refetch: () => Listed | Promise<Listed>;
	maxAttempts: number;
	retryMs: number;
	isAborted?: () => boolean;
	sleep?: (ms: number) => Promise<void>;
}): Promise<Listed> {
	const sleep =
		options.sleep ??
		((ms: number) =>
			new Promise<void>((resolve) => {
				window.setTimeout(resolve, ms);
			}));

	let last: Listed;
	for (let attempt = 0; attempt < options.maxAttempts; attempt++) {
		if (options.isAborted?.()) {
			return last;
		}

		last = await options.refetch();
		if ((last?.items?.length ?? 0) > options.itemCountBefore) {
			return last;
		}

		if (attempt < options.maxAttempts - 1) {
			await sleep(options.retryMs);
		}
	}

	return last;
}
